import styled from "styled-components";
import theme from "../../style/theme";

interface Props {
  value: string;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

export const DeleteButton: React.FC<Props> = ({ value, onClick }) => {
  return (
    <Button value={value} onClick={onClick}>
      삭제하기
    </Button>
  );
};

const Button = styled.button`
  background: transparent;
  border: transparent;
  font-style: normal;
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 1.063rem;
  color: ${theme.palette.primitives.gray300};
  cursor: pointer;

  &:hover {
    font-weight: 600;
    color: ${theme.palette.primitives.red500};
  }
`;
